import React from "react";
import { PublicLayout, PageContainer, PageHeader } from "@/components/PublicLayout";
import { useSeo } from "@/lib/useSeo";

const SECTIONS = [
  { h: "1. Introduction", p: "Guwahati Morning Teer (\"we\", \"our\", \"the website\") respects your privacy. This policy explains what information we collect and how we use it. By using this website you agree to this policy." },
  { h: "2. Information We Collect", p: "We only collect information you voluntarily provide through our contact form, such as your name, optional email address, and message. We do not require account registration for visitors." },
  { h: "3. How We Use Information", p: "Contact form submissions are used solely to respond to your queries and improve our informational service. We do not sell or share your information with third parties for marketing." },
  { h: "4. Cookies & Analytics", p: "We may use basic analytics to understand aggregate traffic patterns. These do not personally identify you." },
  { h: "5. No Financial Transactions", p: "This website does not process payments, betting, or any financial transactions. We never collect payment or banking details." },
  { h: "6. Data Security", p: "We take reasonable measures to protect stored information. However, no method of transmission over the internet is completely secure." },
  { h: "7. Changes to This Policy", p: "We may update this policy from time to time. Continued use of the website constitutes acceptance of any changes." },
  { h: "8. Contact", p: "For any privacy-related questions, please reach us through the Contact page." },
];

export default function Privacy() {
  useSeo({ title: "Privacy Policy | Guwahati Morning Teer", description: "Privacy Policy of Guwahati Morning Teer.", path: "/privacy-policy" });
  return (
    <PublicLayout>
      <PageContainer className="py-10 max-w-3xl">
        <PageHeader eyebrow="Legal" title="Privacy Policy" subtitle="Last updated: 2026" />
        <div className="space-y-6">
          {SECTIONS.map((s, i) => (
            <div key={i} data-testid={`privacy-section-${i}`}>
              <h3 className="font-heading font-bold text-lg text-slate-900">{s.h}</h3>
              <p className="text-slate-600 leading-relaxed mt-1.5">{s.p}</p>
            </div>
          ))}
        </div>
      </PageContainer>
    </PublicLayout>
  );
}
